export const parseStringAmountToFloat = (amount: any) => {
  if(amount === null)
  {
    return 0;
  }
  let cleanUpRegex = /[^0-9\,\.]/g;
  let cleanUpSeparatorsRegex = /[\,\.]/g;
  amount = amount.replace(cleanUpRegex, '');
  var lastSeparatorPosition = Math.max(amount.lastIndexOf(','), amount.lastIndexOf('.'));

  if (lastSeparatorPosition === -1) {
  return parseFloat(amount);            
  }
  var integer = amount.substring(0, lastSeparatorPosition);
  integer = integer.replace(cleanUpSeparatorsRegex, '');
  var decimal = amount.substring(lastSeparatorPosition + 1, amount.length);
  return parseFloat(integer + "." + decimal)
};

export const getTemplateToken = (token: any, defaultValue?: any) => {
  return token ? `${token}` : defaultValue ? `${defaultValue}` : undefined;
};

export const FormatCurrencyNumber = (input: number, separator: any)=>{
  return input.toFixed(2).toString().replace(".", separator);
}

export const FormatMoney = (input: number, currency:any, isCurrencyOnLeft:boolean, separator:any)=>{
  return isCurrencyOnLeft ? currency + " " + FormatCurrencyNumber(input,separator) : FormatCurrencyNumber(input,separator) + " " + currency;
}

export const FormatCurrencyNumberWithOutDecimal = (input: number)=>{
  return input.toFixed(0).toString();
}

export const FormatMoneyWithoutDecimal = (input: number, currency:any, isCurrencyOnLeft:boolean)=>{
  return isCurrencyOnLeft ? currency + " " + FormatCurrencyNumberWithOutDecimal(input) : FormatCurrencyNumberWithOutDecimal(input) + " " + currency;
}

export const hasFractionalPart = (number:number) => {
  return number % 1 != 0;
}

export const tryParseNumber = (value:string, precision:any, updateValueFunc:any) => {
  try {
      if (value == null || !value.toString()) {
          updateValueFunc(0);
          return false;
      }

      var cleanUpRegex = /[^0-9\,\.]/g;
      var cleanUpSeparatorsRegex = /[\,\.]/g;
      value = value.replace(cleanUpRegex, '');

      if (value === '') {
          updateValueFunc(0);
          return false;
      }

      var lastSeparatorPosition = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));

      if (lastSeparatorPosition === -1) {
          updateValueFunc(parseFloat(value));
          return true;
      }

      var integer = value.substring(0, lastSeparatorPosition);
      integer = integer.replace(cleanUpSeparatorsRegex, '');
      var decimal = value.substring(lastSeparatorPosition + 1, value.length);

      if (integer === '' && decimal === '') {
          updateValueFunc(0);
          return false;
      }

      if (decimal.length > precision) {
          decimal = decimal.substring(0, precision);
      }

      updateValueFunc(parseFloat(integer + "." + decimal));
      return true;

  } catch (e) {
      updateValueFunc(0);
      return false;
  }
}
